import { render, staticRenderFns } from "./shipedList.vue?vue&type=template&id=3e20f8a8&"
import script from "./shipedList.vue?vue&type=script&lang=js&"
export * from "./shipedList.vue?vue&type=script&lang=js&"
import style0 from "./shipedList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports